import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLFAWizard from './FNOLFAWizard';
import FNOLFAWhatPage from './pages/What/WhatPage';
import FNOLFABuildingPage from "./pages/FABuilding/BuildingPage";
import FNOLFADetailsPage from "./pages/Details/DetailsPage"

setComponentMapOverrides(
    {
        FNOLFAWizard: { component: 'FNOLFAWizard' },
        FNOLFAWhatPage: { component: 'FNOLFAWhatPage' },
        FNOLFABuildingPage: {component: 'FNOLFABuildingPage'},
        FNOLFADetailsPage: {component: 'FNOLFADetailsPage'}
    },
    {
        FNOLFAWizard,
        FNOLFAWhatPage,
        FNOLFABuildingPage,
        FNOLFADetailsPage
    }
);

export {
    FNOLFAWizard as default
};
